module.exports = __webpack_public_path__ + "static/media/Nikolay_Shkilev.ce554716.jpg";